import {Injectable} from '@angular/core';
import {Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateChild} from '@angular/router';
import {NbAuthService} from '@nebular/auth';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router,
              private authService: NbAuthService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const authenticated = await (new Promise((resolve, reject) => {
      this.authService.isAuthenticated().subscribe((data) => {
        resolve(data);
      })
    }));

    if (!authenticated) {
      this.router.navigate(['/auth/login'], {queryParams: {redirectTo: state.url}});
      return false;
    }

    return true;
  }

  async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return await this.canActivate(route, state);
  }
}
